import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../context/UserProvider';
import { WindowSizeContext } from "../context/WindowSizeProvider";

export default function HomePage()
{
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const { smallScreen } = useContext(WindowSizeContext);

  return <>
    <Helmet>
      <title>Home | NHIDirect</title>
    </Helmet>

    <Stack sx={{ height: "100%", display: "flex", flexDirection: "column" }} >
      <Grid container sx={{ alignItems: "center", px: smallScreen ? 2 : 15 }}>
        <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography sx={{ fontSize: smallScreen ? 30 : 36, mt: 3 }}>Home page coming soon</Typography>
        </Grid>
        <Grid item xs={12} sx={{ mt: 6 }}>
          <img style={{ justifySelf: "center" }} src={"big cloud.png"} alt={"Big Cloud"} loading="lazy" />
        </Grid>
      </Grid>
      <Box sx={{ width: "100%", height: 50, marginTop: "auto", backgroundImage: "url('simple wave pattern.png')" }} />
    </Stack>
  </>;
}